import { UI_STYLES } from "@/styles/uiStyles";


interface ChatHeaderProps {
  count: number;
  astrologistName: string;
  astrologistAvatar: string;
  astrologistDescription: string;
}

export const ChatHeader = ({ count, astrologistName, astrologistAvatar, astrologistDescription }: ChatHeaderProps) => {
  return (
    <div className={`w-full flex flex-col gap-2 ${UI_STYLES.bgDarkBlue4} `}>
    <div className={`w-full flex flex-col gap-2 max-w-md mx-auto`}>
      <div className="  flex items-center gap-3">
        <img
          src={astrologistAvatar}
          alt="avatar"
          className="w-12 h-12 rounded-full object-cover"
        />
        <div className="flex flex-col flex-1">
          <span className="text-white ">{astrologistName}</span>
          <span className="text-white/60 text-xs">
            {astrologistDescription}
          </span>
        </div>
      </div>
      <div className="px-4 pb-2">
        <span className="text-white/60 text-base">
          Осталось вопросов: <span className="">{count}</span>
        </span>
      </div>
    </div>
    </div>
  );
};
